module.exports = __webpack_public_path__ + "static/media/icon-plan.db29c062.svg";